import { TObituaryBookItem } from "@/types/obituary";
import { dateIsoToLocaleString } from "@/utils/date";

const CommentReplies = ({ replies }: TObituaryBookItem) => {
  return (
    <div className="flex flex-col gap-2 pt-4">
      {replies?.map(({ name, timestamp, message }) => {
        return (
          <div className="flex w-full flex-row">
            <div className="mr-1 mt-[21px] h-0.5  min-w-[8px] bg-secondary-200 lg:min-w-[12px]" />
            <div className="flex flex-col gap-1 p-2">
              <p className="text-xl font-semibold text-secondary">{name}</p>
              <p className="text-xs text-secondary-400">
                {dateIsoToLocaleString(timestamp)}
              </p>
              <span dangerouslySetInnerHTML={{ __html: message }} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CommentReplies;
